export const Plans = {
    tiers: ['25+10', '1K', '5K', '10K', '25K', '100K'],
    periods: ['monthly']
}